import { Table, Tag } from 'rbx';
import React from 'react';
import { format } from 'date-fns';

export const LIVE = ['active', 'will_cancel_at_billing_period_end'];

const LABEL = {
  pending: 'Pending payment',
  active: 'Active',
  failed: 'Payment failed',
  will_cancel_at_billing_period_end: 'Cancels at period end',
  cancelled: 'Cancelled',
};

function statusColor(status) {
  switch (status) {
    case 'active':
      return 'success';
    case 'pending':
    case 'will_cancel_at_billing_period_end':
      return 'warning';
    case 'failed':
    case 'cancelled':
      return 'danger';
    default:
      return 'light';
  }
}

export const StatusTag = ({ status }) => (
  <Tag color={statusColor(status)} size="medium">
    {LABEL[status] || status || 'Unknown'}
  </Tag>
);

const date = value => (value ? format(new Date(value), 'do MMM yyyy') : '-');

/**
 * The facts shared by both add-on subscriptions, as label/value rows, plus
 * any product-specific `extra` rows.
 */
function SubscriptionDetails({ subscription, extra = [] }) {
  const { card = {} } = subscription;
  const rows = [
    ['Status', <StatusTag status={subscription.status} />],
    ...(subscription.failureReason
      ? [['Failure reason', subscription.failureReason]]
      : []),
    ['Plan ID', <code>{subscription.planId || '-'}</code>],
    [
      'Price',
      `${subscription.amount ?? '-'} ${subscription.currency || ''}${
        subscription.billingCycle ? ` / ${subscription.billingCycle}` : ''
      }`,
    ],
    ['Next billing', date(subscription.nextBillingDate)],
    ['Cancelled at', date(subscription.cancelledAt)],
    [
      'Card',
      card.lastFour
        ? `${card.brand || ''} •••• ${card.lastFour}${
            card.country ? ` (${card.country})` : ''
          }`
        : '-',
    ],
    ...extra,
    ['Started', date(subscription.createdAt)],
    ['Last update', date(subscription.updatedAt)],
  ];

  return (
    <Table fullwidth>
      <Table.Body>
        {rows.map(([label, value]) => (
          <Table.Row key={label}>
            <Table.Cell>
              <strong>{label}</strong>
            </Table.Cell>
            <Table.Cell>{value}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default SubscriptionDetails;
